export const contractNumberData = {
  title: 'What is your contract number reference?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/d4280ff59897-tooliconnumber6.jpg',
  },
  placeholderText: '',
}
